var _g, _g2, _g3, _g4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPathTextureLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1042.11 585",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "876.77 579.42 876.77 285.33 1023 285.33",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1014.02 297.18 1019.05 285.33 1014.02 273.48 1042.11 285.33 1014.02 297.18",
    fill: "#231f20"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1002.99,
    y1: 551,
    x2: 1002.99,
    y2: 19.1,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1014.84 28.09 1002.99 23.06 991.14 28.09 1002.99 0 1014.84 28.09",
    fill: "#231f20"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "266.77 583 266.77 385.67 177.43 385.67",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.42 373.82 181.38 385.67 186.42 397.52 158.33 385.67 186.42 373.82",
    fill: "#231f20"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "93.44 551 93.44 259.59 10.63 73.64",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77,56c6.78,6.93,16.62,14.89,25.03,18.79l-16.14,1.16L0,87.18c2.72-8.86,3.39-21.5,2.77-31.18Z",
    fill: "#231f20"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94.02,
    cy: 571.92,
    r: 20.92,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 266.77,
    cy: 600.33,
    r: 20.92,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 876.77,
    cy: 600.33,
    r: 20.92,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1002.99,
    cy: 571.92,
    r: 20.92,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 409.36,
    cy: 593.33,
    r: 20.92,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 471.72,
    cy: 593.33,
    r: 20.92,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 534.08,
    cy: 592.83,
    r: 20.92,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 596.44,
    cy: 593.33,
    r: 20.92,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.8,
    cy: 592.83,
    r: 20.92,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 596.44,
    cy: 749.27,
    r: 20.92,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M612.67,736.08s84.11-54.99,89.44-183.62c4.16-100.32-17.63-206.64-27.43-248.58",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "688.26 309.83 675.55 307.74 665.23 315.43 670.11 285.33 688.26 309.83",
    fill: "#231f20"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 75.31,
    y1: 481.14,
    x2: 111.57,
    y2: 517.22,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.31,
    y1: 517.22,
    x2: 111.57,
    y2: 481.14,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 248.65,
    y1: 202.29,
    x2: 284.9,
    y2: 238.38,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.65,
    y1: 238.38,
    x2: 284.9,
    y2: 202.29,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 693.09,
    y1: 68.62,
    x2: 729.34,
    y2: 104.71,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 693.09,
    y1: 104.71,
    x2: 729.34,
    y2: 68.62,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 822.66,
    y1: 495.6,
    x2: 858.92,
    y2: 531.68,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 822.66,
    y1: 531.68,
    x2: 858.92,
    y2: 495.6,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 352.18,
    y1: 524.79,
    x2: 388.44,
    y2: 560.87,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.18,
    y1: 560.87,
    x2: 388.44,
    y2: 524.79,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 461.8,
    y1: 524.79,
    x2: 498.06,
    y2: 560.87,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.8,
    y1: 560.87,
    x2: 498.06,
    y2: 524.79,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 546.42,
    y1: 488.7,
    x2: 582.68,
    y2: 524.79,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 546.42,
    y1: 524.79,
    x2: 582.68,
    y2: 488.7,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 619.75,
    y1: 524.79,
    x2: 656.01,
    y2: 560.87,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 619.75,
    y1: 560.87,
    x2: 656.01,
    y2: 524.79,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 693.09,
    y1: 524.79,
    x2: 729.34,
    y2: 560.87,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 693.09,
    y1: 560.87,
    x2: 729.34,
    y2: 524.79,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 406.99,
    y1: 506.75,
    x2: 443.25,
    y2: 542.83,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 406.99,
    y1: 542.83,
    x2: 443.25,
    y2: 506.75,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 984.87,
    y1: 488.7,
    x2: 1021.12,
    y2: 524.79,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 984.87,
    y1: 524.79,
    x2: 1021.12,
    y2: 488.7,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathTextureLarge);
export default __webpack_public_path__ + "static/media/path-texture-large.adb06e8fe965311b631ff2e756f73a99.svg";
export { ForwardRef as ReactComponent };